export class ReportFinancialSnapshotFilterModel {
  PracticeLocations: string[];
  ProvidersId: string[];
  PracticeId: number;
  ProviderId: string;
  TypeId: string;
  OrderBy: string;
  dateRange: string;
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  isCurrentMonth: boolean;
  isAsc: boolean;
  showInactive: boolean;
  isInteractiveReport: boolean;
}
